// eslint-disable-next-line import/no-anonymous-default-export
export default {
  installation: {
    common: {
      update: "Update",
      packageInformation: "Installation Package Information",
      packageUpload: "Upload Installation Package",
      packageName: "Installation Package Name",
      productName: "Product Name",
      sku: "version",
      version: {
        community: "Community",
        enterprise: "Enterprise",
      },
      versionId: "Version Number",
      publishTime: "Publish Time",
      robot: "Robot",
      studio: "Studio",
      android: "Android",
      ios: "IOS",
      appium: "AndroidV2（Beta）",
      ocr: "OfflineOCR",
      fileName: "File Name",
      fileSize: "File Size",
      uploadByName: "Founder",
      notUpload: "Not Upload",
      uploadFailed: "{fileName} {type} Upload Failed",
      uploadSuccessfully: "{fileName} {type} Upload Successfully",
      mainFile: "Main File",
      extFile: "Additional Files",
      mainTip: "Please upload the following main file, for example: {file}",
      extTip:
        "and the following two additional files, for example: {extOne} and {extTwo}",
      errorSuffix: "{suffix} file already exists, please delete it first!",
      errorAllowed: "{file} is an invalid file type",
      firstRemove: "Please delete additional files first",
      create: "Create",
      publish: "Publish",
      publishPackage:
        "Do you want to publish the current installation package: {package}?",
      publishSuccessfully: "Publish Successfully",
      createSuccessfully: "Create Successfully",
      deleteSuccessfully: "Delete Successfully",
      deleteInstation: "Are you sure to delete {name} ?",
      inComplete: "The uploaded file is incomplete, please continue uploading",
      tip: "If you want to replace the current file, upload it directly to overwrite it",
    },
    input: {
      packageName: "Please enter the installation package name",
      sku: "Please select version",
    },
  },
};
